import { render } from "./DoctorHistory.vue?vue&type=template&id=3eb59c90&scoped=true"
import script from "./DoctorHistory.vue?vue&type=script&lang=js"
export * from "./DoctorHistory.vue?vue&type=script&lang=js"

import "./DoctorHistory.vue?vue&type=style&index=0&id=3eb59c90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb59c90"]])

export default __exports__